module.exports = __webpack_public_path__ + "img/hlhkzxt2.fe82f277.jpg";